import React from 'react';
import { LoadingIndicator } from '../shared/components/LoadingIndicator';

export function AppLoading() {
  return <LoadingIndicator />;
}
